// extracted by mini-css-extract-plugin
module.exports = {"note":"PassModal_note__2jZHX","icon":"PassModal_icon__1u4jZ"};